import { useMemo, useState } from 'react';
import { useElementSize } from '@lingoda/hooks';
import { MIN_HEIGHT_HEADER } from '@lingoda/ui/theme/common';

export const useHeaderBars = () => {
    const [navHeaderRef, setNavHeaderRef] = useState<HTMLDivElement | null>();
    const [notificationBarsRef, setNotificationBarsRef] = useState<HTMLDivElement | null>();
    const [timezoneBannerRef, setTimezoneBannerRef] = useState<HTMLDivElement | null>(null);
    const [fFreeTrialCountdownRef, setFFreeTrialCountdown] = useState<HTMLDivElement | null>(null);

    const notificationBarsHeight = useElementSize(notificationBarsRef, 'clientHeight');
    const timezoneBannerHeight = useElementSize(timezoneBannerRef, 'clientHeight');
    const navHeaderHeight = useElementSize(navHeaderRef, 'offsetHeight', {
        defaultValue: MIN_HEIGHT_HEADER,
    });
    const fFreeTrialCountdownHeight = useElementSize(fFreeTrialCountdownRef, 'clientHeight');

    const wholeHeaderHeight =
        timezoneBannerHeight + navHeaderHeight + notificationBarsHeight + fFreeTrialCountdownHeight;
    const refs = useMemo(
        () => ({
            navHeader: setNavHeaderRef,
            notificationBars: setNotificationBarsRef,
            timezoneBanner: setTimezoneBannerRef,
            fFreeTrialCountdown: setFFreeTrialCountdown,
        }),
        [],
    );

    return {
        wholeHeaderHeight,
        refs,
    };
};
